//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeRegister,
  postJwtRegister,
} from "../../../helpers/fakebackend_helper";

// action
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange
} from "./reducer";

// initialize relavant method of both Auth
const fireBaseBackend = getFirebaseBackend();

// Is user register successfull then direct plot user in redux.
export const registerUser = (user) => async (dispatch) => {
  try {
    const data = await postFakeRegister(user);
    console.log("[registerUser] response:", data);
    if (data && data.success) {
      dispatch(registerUserSuccessful(data));
    } else {
      const msg = (data && typeof data.message === "string" && data.message)
        || (typeof data === "string" && data)
        || "Failed to register. Please try again.";
      dispatch(registerUserFailed(msg));
    }
  } catch (error) {
    console.log("[registerUser] caught error:", error);
    const msg = (typeof error === "string" && error)
      || (error && error.message)
      || (error && error.response && error.response.data && error.response.data.message)
      || "Failed to register. Please try again.";
    dispatch(registerUserFailed(msg));
  }
};

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};

export const apiError = () => {
  try {
    const response = apiErrorChange();
    return response;
  } catch (error) {
    return error;
  }
};